
export class validation {

    static NameRegex = /^[A-Za-z\'\s\.\:\-]+$/;

  
}

export default validation
